import axios from "axios";
import { getAccessToken, handleTokenExpiry, isTokenExpiryResponse } from "../global/auth.global";

const BASE_URL = process.env.REACT_APP_API_DOMAIN;

export const aiAxios = axios.create({
  baseURL: `${BASE_URL}/ai`,
  headers: {
    "Content-Type": "application/json",
  },
});

aiAxios.interceptors.request.use((request) => {
  const token = getAccessToken();
  request.headers["Authorization"] = token ? "Bearer " + token : "";
  return request;
});

aiAxios.interceptors.response.use(
  (response) => {
    if (response.status === 200 || response.status === 204)
      return response.data;
    return Promise.reject(response.data);
  },
  (error) => {
    const { response } = error;

    if (isTokenExpiryResponse(response)) {
      handleTokenExpiry();
      return Promise.reject({ message: "Session expired" });
    }

    const message = response?.data || "Something Went Wrong";
    return Promise.reject(message);
  }
);
